export default __webpack_public_path__ + "static/media/02.b98e5c0b.jpg";